import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { FinanceReportDTO } from './types'

export const WORKSPACE_FRAGMENT_FOR_FINANCE_REPORT: TypedDocumentNode<FinanceReportDTO> = gql`
  fragment WorkspaceFragmentForFinanceReport on Workspace {
    id
    financeReportUrl
    users {
      id
      email
    }
  }
`
